import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useAuthStore,
  useIsUserSignedIn,
} from "../../core_stores/useAuthStore";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import { useProjectBuildActions } from "../../core_stores/useProjectBuildsStore";
import { useProjectExportsActions } from "../../core_stores/useProjectExportsStore";
import { useProjectActions } from "../../core_stores/useProjectStore";
import { useAuthModal } from "../../providers/AuthModalProvid";
import { trackPageview } from "../../utils/analyticsUtils";
import { useChatMessagesActions } from "../../view_stores/chat_messages/useChatMessagesStore";
import { useProjectConfigActions } from "../../view_stores/useProjectConfigStore";
import { useProjectPreviewActions } from "../../view_stores/useProjectPreviewStore";
import { useProjectStatusActions } from "../../view_stores/useProjectStatusStore";
import { usePromptInputActions } from "../../view_stores/usePromptInputStore";
import { useRollbackErrorHandlerActions } from "../../view_stores/useRollbackErrorHandlerStore";
import { useRollbackHandlerActions } from "../../view_stores/useRollbackHandlerStore";
import { useSideMenuActions } from "../../view_stores/useSideMenuStore";
import { useTechnicalErrorHandlerActions } from "../../view_stores/useTechnicalErrorHandlerStore";
import { WelcomePageCompact } from "./WelcomePageCompact";
import { WelcomePageDefault } from "./WelcomePageDefault";

export function WelcomePage() {
  const { setSelectedProjectId } = useSideMenuActions();
  const { dispose: disposeProject } = useProjectActions();
  const { dispose: disposeChatMessages } = useChatMessagesActions();
  const { dispose: disposeProjectStatus } = useProjectStatusActions();
  const { dispose: disposeTechnicalErrorHandler } =
    useTechnicalErrorHandlerActions();
  const { dispose: disposeRollbackErrorHandler } =
    useRollbackErrorHandlerActions();
  const { dispose: disposePreview } = useProjectPreviewActions();
  const { dispose: disposeProjectConfig } = useProjectConfigActions();
  const { dispose: disposeProjectBuilds } = useProjectBuildActions();
  const { dispose: disposeProjectExports } = useProjectExportsActions();
  const {
    loadFromLocalStorage: loadPromptFromLocalStorage,
    clear: clearPromptInput,
  } = usePromptInputActions();
  const { reset: resetRollbackHandler } = useRollbackHandlerActions();

  useEffect(() => {
    setSelectedProjectId(null);
    disposeProject();
    disposeChatMessages();
    disposeProjectStatus();
    disposeTechnicalErrorHandler();
    disposeRollbackErrorHandler();
    disposePreview();
    disposeProjectConfig();
    disposeProjectBuilds();
    disposeProjectExports();
    clearPromptInput();
    loadPromptFromLocalStorage();
    resetRollbackHandler();
  }, []);

  return <Content />;
}

function Content() {
  const isUserSignedIn = useIsUserSignedIn();
  const isCompactView = useIsCompactView();
  const location = useLocation();
  const navigate = useNavigate();

  const { show: showAuthModal } = useAuthModal();

  useEffect(() => {
    trackPageview("Welcome");
  }, []);

  const tryToSignInAndRedirectProject = async (redirectProjectId: string) => {
    await showAuthModal();
    const isUserSignedIn = useAuthStore.getState().user !== null;
    if (isUserSignedIn) {
      navigate(`/project/${redirectProjectId}`, { replace: true });
    }
    window.history.replaceState({}, document.title);
  };

  useEffect(() => {
    const shouldShowAuthModal = location.state?.showAuthModal;
    const redirectProjectId = location.state?.redirectProjectId;

    if (shouldShowAuthModal && !isUserSignedIn) {
      tryToSignInAndRedirectProject(redirectProjectId);
    }
  }, [location.state, isUserSignedIn]);

  return isCompactView ? <WelcomePageCompact /> : <WelcomePageDefault />;
}
